import { render, staticRenderFns } from "./my-enquiries.vue?vue&type=template&id=95e2c368&"
import script from "./my-enquiries.vue?vue&type=script&lang=ts&"
export * from "./my-enquiries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports